export default __webpack_public_path__ + "static/media/support-and-feedback.c4c08bf2.svg";